export const ForcePlateIcon = ({ color = "#19213D" }) => {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_530_9333"
        // eslint-disable-next-line react/style-prop-object
        // style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="1"
        y="2"
        width="14"
        height="11"
      >
        <path
          d="M6.08337 2.91663H13.0834C13.2381 2.91663 13.3865 2.97808 13.4959 3.08748C13.6053 3.19688 13.6667 3.34525 13.6667 3.49996V11.0833C13.6667 11.238 13.6053 11.3864 13.4959 11.4958C13.3865 11.6052 13.2381 11.6666 13.0834 11.6666H6.08337"
          stroke="white"
        />
        <path
          d="M2 3.49996C2 3.34525 2.06146 3.19688 2.17085 3.08748C2.28025 2.97808 2.42862 2.91663 2.58333 2.91663H6.08333V11.6666H2.58333C2.42862 11.6666 2.28025 11.6052 2.17085 11.4958C2.06146 11.3864 2 11.238 2 11.0833V3.49996Z"
          fill="white"
          stroke="white"
        />
        <path
          d="M4.04163 4.95825V6.12492"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.625 4.66663L8.125 9.62496"
          stroke="white"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.62504 7.87496C4.62504 7.55279 4.36387 7.29163 4.04171 7.29163C3.71954 7.29163 3.45837 7.55279 3.45837 7.87496C3.45837 8.19713 3.71954 8.45829 4.04171 8.45829C4.36387 8.45829 4.62504 8.19713 4.62504 7.87496Z"
          fill="black"
        />
        <path
          d="M4.62504 9.62496C4.62504 9.30279 4.36387 9.04163 4.04171 9.04163C3.71954 9.04163 3.45837 9.30279 3.45837 9.62496C3.45837 9.94713 3.71954 10.2083 4.04171 10.2083C4.36387 10.2083 4.62504 9.94713 4.62504 9.62496Z"
          fill="black"
        />
      </mask>
      <g mask="url(#mask0_530_9333)">
        <path d="M0.833374 0H14.8334V14H0.833374V0Z" fill={color} />
      </g>
    </svg>
  );
};
